/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* DELIVERYNOTE */
export const SET_DELIVERYNOTE_LIST = "SET_DELIVERYNOTE_LIST";
export const ADD_NEW_DELIVERYNOTE = "ADD_NEW_DELIVERYNOTE";
export const UPDATE_DELIVERYNOTE = "UPDATE_DELIVERYNOTE";
export const DELETE_DELIVERYNOTE = "DELETE_DELIVERYNOTE";
export const OPEN_DELIVERYNOTE_FORM = "OPEN_DELIVERYNOTE_FORM";
export const CLOSE_DELIVERYNOTE_FORM = "CLOSE_DELIVERYNOTE_FORM";
export const EDIT_SELECTED_DELIVERYNOTE = "EDIT_SELECTED_DELIVERYNOTE";
export const DELIVERYNOTE_FORM_TOOGLE_LOADING = "DELIVERYNOTE_FORM_TOOGLE_LOADING";
/* <---- DELIVERYNOTE ----> */

/* INVOICE */
export const SET_INVOICE_LIST = "SET_INVOICE_LIST";
export const ADD_NEW_INVOICE = "ADD_NEW_INVOICE";
export const UPDATE_INVOICE = "UPDATE_INVOICE";
export const DELETE_INVOICE = "DELETE_INVOICE";
export const OPEN_INVOICE_FORM = "OPEN_INVOICE_FORM";
export const CLOSE_INVOICE_FORM = "CLOSE_INVOICE_FORM";
export const EDIT_SELECTED_INVOICE = "EDIT_SELECTED_INVOICE";
export const INVOICE_FORM_TOOGLE_LOADING = "INVOICE_FORM_TOOGLE_LOADING";
/* <---- INVOICE ----> */

/* PRODUCT */
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const OPEN_PRODUCT_FORM = "OPEN_PRODUCT_FORM";
export const CLOSE_PRODUCT_FORM = "CLOSE_PRODUCT_FORM";
export const EDIT_SELECTED_PRODUCT = "EDIT_SELECTED_PRODUCT";
export const PRODUCT_FORM_TOOGLE_LOADING = "PRODUCT_FORM_TOOGLE_LOADING";
/* <---- PRODUCT ----> */

/* CLIENT */
export const SET_CLIENT_LIST = "SET_CLIENT_LIST";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const OPEN_CLIENT_FORM = "OPEN_CLIENT_FORM";
export const CLOSE_CLIENT_FORM = "CLOSE_CLIENT_FORM";
export const EDIT_SELECTED_CLIENT = "EDIT_SELECTED_CLIENT";
export const CLIENT_FORM_TOOGLE_LOADING = "CLIENT_FORM_TOOGLE_LOADING";
/* <---- CLIENT ----> */

/* CONFIGURATION */
export const SET_CONFIGURATION_LIST = "SET_CONFIGURATION_LIST";
export const ADD_NEW_CONFIGURATION = "ADD_NEW_CONFIGURATION";
export const UPDATE_CONFIGURATION = "UPDATE_CONFIGURATION";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const OPEN_CONFIGURATION_FORM = "OPEN_CONFIGURATION_FORM";
export const CLOSE_CONFIGURATION_FORM = "CLOSE_CONFIGURATION_FORM";
export const EDIT_SELECTED_CONFIGURATION = "EDIT_SELECTED_CONFIGURATION";
export const CONFIGURATION_FORM_TOOGLE_LOADING = "CONFIGURATION_FORM_TOOGLE_LOADING";
/* <---- CONFIGURATION ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
